import React, { useState, useRef, useMemo, useEffect } from 'react';
import JoditEditor from "jodit-react";

const JoditEditorExample = (props) => {
    const { placeholder, htmlContent, onBlur } = props;
    const editor = useRef(null)
    const [content, setContent] = useState('')
    useEffect(() => {
        if (typeof htmlContent !== 'string'&&htmlContent) {
            setContent(`${htmlContent}`);
        } else {
            setContent(htmlContent);
        }
    }, [htmlContent]);

    // const config = useMemo(() => ({
    //     readonly: false,
    //     placeholder: placeholder || 'Start typings...',
    //     disablePlugins: ['table,iframe'],
    //     editHTMLDocumentMode: true,
    // }), [placeholder])

    const config = useMemo(()=>({
        present: 'document',
        editHTMLDocumentMode: true,
        spellCheck: true,
        iframe: true,
        uploader: {
          insertImageAsBase64URI: true
        },
        direction: "ltr",
        enter: "BR",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false

    }), [placeholder])

    return (
        <JoditEditor
            ref={editor}
            config={config}
            value={content ?? ''}
            onBlur={newContent => {
                setContent(newContent);
                if (onBlur != null) {
                    onBlur({ target: { value: newContent } });
                }
            }}
        />
    );
}

export default JoditEditorExample;